import React from 'react';
import allContribs from '../data/chief-contributors.json';
import { ChiefCard, type ContribEntry } from './ChiefCard';

export function ChiefContributorRow() {
  const list = allContribs as ContribEntry[];
  return (
    <div className="chief-row-wrap">
      <section
        role="list"
        aria-label={`${list.length} contributors`}
        className="chief-row-scroll"
      >
        {list.map(c => (
          <div role="listitem" key={c.id}>
            <ChiefCard chief={c} />
          </div>
        ))}
      </section>
    </div>
  );
}
